import { h } from 'preact'
import styles from './TeamLogo.module.css'

const vmLogoSmall = require('../../static/vm-favicon-16x16.png').default

interface Props {
  logoUrl: string
}

export function TeamLogo(props: Props) {
  return (
    <img
      className={styles['dh-fotball-banner__match-teams-logo']}
      src={`${logoFile(props.logoUrl)}`}
      alt=""
      aria-hidden="true"
    />
  )
}

function logoFile(logoUrl) {
  return logoUrl ? logoUrl : vmLogoSmall
}
